import React from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import "./index.scss";
import expertImg from "../../../assets/images/expert.png";
import { ExpertIcon } from "../../../assets/icons/ExpertIcon";
import { FleshIcon } from "../../../assets/icons/FleshIcon";
import { useTranslation } from "react-i18next";

export default function ExpertSection() {
  const { t } = useTranslation();

  return (
    <div className="expert-section my-3 my-md-5">
      <Row className="h-100">
        <Col md={7} className="mb-3">
          <Row className="mb-1 mb-md-4">
            <Col md={4} xs={12} className="mb-3">
              <Card className="stat-card">
                <div className="icon">
                  <ExpertIcon />
                </div>
                <h2>07+</h2>
                <p>{t("years_experience")}</p>
              </Card>
            </Col>

            <Col md={4} xs={12} className="mb-3">
              <Card className="stat-card active">
                <div className="icon">
                  <ExpertIcon />
                </div>
                <h2>50 +</h2>
                <p>{t("successful_projects")}</p>
              </Card>
            </Col>

            <Col md={4} xs={12} className="mb-3">
              <Card className="stat-card">
                <div className="icon">
                  <ExpertIcon />
                </div>
                <h2>04</h2>
                <p>{t("competency_poles")}</p>
              </Card>
            </Col>
          </Row>

          <div className="expert-text p-2 p-md-4">
            <h3>{t("experts_network_text")}</h3>
          </div>
        </Col>

        <Col md={5} className="mb-3 h-auto">
          <Row className="align-items-center h-100">
            <Col md={12} className="mb-3 h-100">
              <div className="expert-img-container position-relative">
                <Button className="circle-btn">
                  <FleshIcon />
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
